import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import SignaturePad from 'signature_pad';
import { LanguageService } from '../../../services/language.service';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import { Visitor } from '../../models/visitor.model';
import { VisitorService } from '../../services/visitor.service';
import { NotifierService } from 'angular-notifier';
import { VisitorChild } from '../../models/visitorChild';
import { AddChildModalComponent } from '../../components/modals/add-child-modal/add-child-modal.component';
import { IonModal, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-group-registration',
  templateUrl: './group-registration.page.html',
  styleUrls: ['./group-registration.page.scss'],
})
export class GroupRegistrationPage {
  @ViewChild('canvas', { static: true }) signaturePadElement;
  @ViewChild('registerDoc')
  registerDoc!: ElementRef;
  @ViewChild('terms')
  terms!: ElementRef;
  @ViewChild('visitorForm')
  visitorForm!: ElementRef;
  @ViewChild('dateLabel')
  dateLabel!: ElementRef;
  language$ = this.languageService.language$;
  language: string;
  dateToday = new Date();
  errMsg = '';
  areTermsRead: boolean = false;
  visitor: Visitor = new Visitor();
  isLoading = false;
  visitors: Array<VisitorChild> = [];
  childEdit: VisitorChild;
  // isShow = true;
  routerSubscription;
  date: string | any;
  month: string = ''
  year: string = '';
  datei: string | any;
  months: string | any;
  years: string | any;
  telephoneG: string | any;
  emailg: string | any;
  addressg: string | any;

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private languageService: LanguageService,
    private visitorService: VisitorService,
    private notifierService: NotifierService,
    private modalController: ModalController
  ) {
    this.childEdit = new VisitorChild();

    this.childEdit = new VisitorChild();
    this.routerSubscription = this.router.events.subscribe((route: any) => {
      // clear data once we redirect to home
      if(route.url === '/registration/home') {
        this.visitor = new Visitor();
        this.visitors = [];
        this.date = '';
        this.month = '';
        this.year = '';
      }
    })
  }

  pagePath: string;
  signaturePad: any;
  isSignatured: boolean = false;

  ngOnInit() {
    this.visitor = new Visitor();
    this.language$.subscribe((lng) => (this.language = lng.toUpperCase()));
    this.pagePath = this.router.url;
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  clear() {
    this.signaturePad.clear();
    this.isSignatured = false;
  }

  setIsSignatured() {
    this.isSignatured = true;
  }

  isCanvasBlank(): boolean {
    if (this.signaturePad) {
      return this.signaturePad.isEmpty() ? true : false;
    }
  }

  showSuccessAndRedirect() {
    this.notifierService.show({
      message: 'Poseta uspešno registrovana!',
      type: 'success',
    });
    this.visitor = new Visitor();
    this.visitors = [];
    this.areTermsRead = false;
    this.signaturePad.clear();
    this.router.navigateByUrl('/registration/home');
  }

  areFieldsPopulated(): boolean {
    const v = this.visitor;
    return !!(
      this.isSignatured &&
      this.areTermsRead &&
      v.fullName &&
      v.address &&
      v.city &&
      v.email &&
      v.phone &&
      this.date &&
      this.month &&
      this.year
    );
  }

  validateAddVisitor() {
    const user = this.visitor;
    let errMsg: string;
    if (!user.fullName) {
      errMsg = 'Unesite ime roditelja / staratelja.';
    }
    // else if (!user.children) {
    //   errMsg = 'Unesite ime korisnika.'; }
      else if (!user.email) {
      errMsg = 'Unesite e-mail adresu.';
    } else if (!user.phone) {
      errMsg = 'Unesite broj telefona.';
    } else if (!user.address) {
      errMsg = 'Unesite adresu.';
    } else if (!user.city) {
      errMsg = 'Unesite grad.';
    } 
    else {
      errMsg = '';
      return { isValid: true, errMsg };
    }
    return { isValid: false, errMsg };
  }

  areFirstFieldsPopulated(): boolean {
    const v = this.visitor;
    return !!(
      v.fullName &&
      v.address &&
      v.city &&
      v.email &&
      v.phone &&
      this.date &&
      this.month &&
      this.year 
    );
  }

  resetForm(i)  {
    this.visitors.splice(i,1);
  }

  async toggleDisplay() {
    
      // this.toggleDisplay2();
      const modal = await this.modalController.create({
      component: AddChildModalComponent,
      componentProps: {childEdit : this.childEdit, visitors:this.visitors},
      cssClass: 'basic-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });

    modal.onDidDismiss()
      .then((data) => {
        const child:VisitorChild = data['data'];
        if(child!=null)
          this.visitors.push(child);
    });
    this.childEdit.fullName='';
    await modal.present();
  }

  goToOtherPage() {
   const formValidation = this.validateAddVisitor();
   this.errMsg = formValidation.errMsg;
  
   let visitorJson = JSON.stringify(this.visitor);
   let visitorsJson = JSON.stringify(this.visitors);
   if (formValidation.isValid) {
   this.router.navigate(['/registration/consent-group-visit', {visitor:visitorJson, visitors:visitorsJson}]);
 }
}



    gotoNextField(nextElement){
        nextElement.setFocus();
    }
 
}
